import Axios from 'axios'
import * as constants from '../helpers/Constants.js'
import Models from '@/store/ORM/models.js';

var infoApi = Axios.create({
  baseURL:constants.APIURL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
})

infoApi.interceptors.response.use((response) =>{
  return response
},  (error) =>{
  if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('loggedin');
      localStorage.removeItem('vuex');

      
      Models.Reference.deleteAll();
      Models.Supplier.deleteAll();
      Models.Specialist.deleteAll();
      Models.CreatedMenu.deleteAll();
      Models.Specialist.deleteAll();
      Models.Nutritionist.deleteAll();
      Models.Client.deleteAll();
      Models.Event.deleteAll();
      Models.Product.deleteAll();

      let urls = window.location.href.split('#');
      window.open(urls[0],'_self');
  }
  return Promise.reject(error)
})




const getHelpEndpoint = "api/v1/help";
const getAboutEndpoint = "api/v1/about-us";
const getHowToEndpoint = "api/v1/how-to-page";
const getDietTypesEndpoint = "api/v1/get-diets";
const getServingSizesEndpoint = "api/v1/get-servings";
const getActivitiesEndpoint = "api/v1/get-activities/";
const getUserEndpoint = "api/v1/user";
const getTipsEndpoint = "api/v1/tips";

export default {

  refreshAxios(){
    infoApi = Axios.create({
      baseURL:constants.APIURL,
      withCredentials: false, // This is the default
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
  },
  getHelp() {
    return infoApi.get(getHelpEndpoint);
  },
  getAbout(){
    return infoApi.get(getAboutEndpoint);
  },
  getDietTypes(){
    return infoApi.get(getDietTypesEndpoint);
  },
  getServingSizes(){
    return infoApi.get(getServingSizesEndpoint);
  },
  getActivities(client_id){
    return infoApi.get(getActivitiesEndpoint+client_id);
  },
  getHowTo(){
    return infoApi.get(getHowToEndpoint);
  },
  getUser(){
    return infoApi.get(getUserEndpoint);
  },
  getTips(){
    return infoApi.get(getTipsEndpoint);
  }
}
